// src/api/bchTeam.js
import { apiGet } from "./http";

/**
 * =========================
 * BCH 团队网络管理
 * =========================
 */

/**
 * GET /app/bch/team/overview
 *
 * 获取当前登录用户的团队网络总览。
 *
 * 用户地址由后端从登录 Token 中获取，
 * 前端不需要、也不允许传入 userCode。
 *
 * 返回数据主要包括：
 *
 * 1. 当前等级
 *    - currentLevel: 当前等级名称，例如 B1、B2、B3
 *    - currentLevelValue: 当前计算等级数字
 *    - storedLevelValue: 数据库保存的等级数字
 *
 * 2. 晋级信息
 *    - nextLevel: 下一等级
 *    - needMore: 距离下一等级还差多少小区业绩
 *    - levelRules: B1-B5 等级配置
 *
 * 3. 团队统计
 *    - directCount: 直推人数
 *    - teamCount: 团队总人数，不包含自己
 *    - selfPerformance: 自己的个人业绩
 *    - totalTeamPerformance: 所有直属团队分支业绩总和
 *    - maxBranchPerformance: 最大团队分支业绩
 *    - areaPerformance: 小区业绩
 *
 * 4. 团队分支
 *    - branches: 所有直属团队分支
 *    - directMembers: 直属成员列表
 *
 * 小区业绩计算规则：
 *
 * areaPerformance =
 * totalTeamPerformance - maxBranchPerformance
 *
 * @param {Object} config 请求配置，例如取消请求、静默错误等
 * @returns {Promise}
 */
export function fetchBchTeamOverview(config = {}) {
  return apiGet("/app/bch/team/overview", {}, config);
}

/**
 * =========================
 * 兼容名称导出
 * =========================
 *
 * 页面中可以根据命名习惯选择使用。
 */

export const fetchTeamOverview = fetchBchTeamOverview;
export const fetchBchTeam = fetchBchTeamOverview;